export enum StrategyType {
    Export = 0,
    Import = 1,
    Process = 2,
    PowerAutomate = 3,
    Api = 4,
    Share = 5,
    Other = 6,
}